export const MaybernTableSizes = {
  headerHeight: 56,
  groupHeaderHeight: 35,
  rowHeight: 42,
  paginationRowHeight: 36,
};

export const ActionCellClass = "mb-cell-actions-cell";
export const ClickableRowClass = "mb-row-is-clickable";
export const maybernCellErrorClass = "mb-cell-error";
